import React, { Component } from 'react';
import Lokal from "../images/lokal/Lokal-logo-B.png"
import card from "../images/lokal/card.webp"
import { Link } from 'react-router-dom';
import { getData } from '../services';
import LazyLoad from 'react-lazyload';
export default class Footer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            footerDatas: [],
            isAppData: [],
            isMediaData: [],
            isData: []
        }
    }
    componentDidMount() {
        const postData = {
            "functionName": "lokal/footerLink",
            "siteCategoryGroupId": window.sessionStorage.getItem('siteCategoryId')
        }
        getData(postData).then((data) => {
            if (data.data.success === "1") {
                this.setState({ footerDatas: data.data.siteGroupData })
                let isAppFilter = data.data.siteGroupData[0].footerLink.filter((obj) => {
                    return obj.is_app === 1
                })
                this.setState({
                    isAppData: isAppFilter
                })
                let isMediaFilter = data.data.siteGroupData[0].footerLink.filter((obj) => {
                    return obj.is_media === 1
                })
                this.setState({
                    isMediaData: isMediaFilter
                })
                let isFilter = data.data.siteGroupData[0].footerLink.filter((obj) => {
                    return (obj.is_media === 0 && obj.is_app === 0)
                })
                this.setState({
                    isData: isFilter
                })
            }
        })
    }
    render() {
        var siteUrlPathname = window.location.pathname;
        var subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
        let sessionSiteDetails = window.sessionStorage.getItem('siteDetails');
        var siteDetails = JSON.parse(sessionSiteDetails);
        let storeLogoPath = siteDetails.siteData[0].logoPath;
        return (
            <div>
                {this.state.footerDatas.map((lokalObj, index) =>
                    <div key={index} id="footerLokal" className="footerSection">
                        <div className="container">
                            <div className="menuListView" >
                                <div className="mainMenuList">
                                    <LazyLoad once>
                                        <img alt="" src={(localStorage.getItem('themeId') === '34' && (window.sessionStorage.getItem('siteCategoryId') !== "5" && window.sessionStorage.getItem('siteCategoryId') !== "7" ))? Lokal : (window.sessionStorage.getItem('siteCategoryId') === "5" || window.sessionStorage.getItem('siteCategoryId') === "7")? storeLogoPath : localStorage.getItem('logoPath') } className="footerLogo" />
                                    </LazyLoad>
                                    <span className="copyRight">© Copyright {new Date().getFullYear()}</span>
                                </div>
                                {this.state.isAppData.length > 0 ?
                                    <div className="mainMenuList">
                                        <span className="menuName">Application</span>
                                        {this.state.isAppData.map((item, index2) =>
                                            <div className="appSection">
                                                <a href={item.url} aria-label="Applications">
                                                    <LazyLoad once>
                                                        <img src={item.imageFullPath} alt="" />
                                                    </LazyLoad>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                    : ""}
                                <div className="mainMenuList">
                                    <span className="menuName">About {window.sessionStorage.getItem("groupName")}</span>
                                    <ul>
                                        {localStorage.getItem('themeId') === '34' ?
                                            <>
                                                <li ><Link to="/aboutNew">About Us</Link></li>
                                                {lokalObj.footerLink.map((footerLinkObj, index1) =>
                                                    (() => {
                                                        if (footerLinkObj.name === 'Contact Us') {
                                                            return (
                                                                <li key={index1}><Link to={{ pathname: "/footerContent/" + footerLinkObj.id, state: { footerData: footerLinkObj } }} >{footerLinkObj.name}</Link></li>
                                                            )
                                                        }
                                                    })()
                                                )}
                                            </>
                                            : ""}
                                        {localStorage.getItem('sellerRegisterationFlag') === '1' ?
                                            <li className="seller-reg-gsa mt-2"><Link to="/registrationForSeller">Seller Registration</Link></li>
                                            : ""}
                                    </ul>
                                </div>
                                {(() => {
                                    if (subDomainFlag === "1" || siteUrlPathname.indexOf("STORE-") !== (-1) || siteUrlPathname.indexOf("listing") !== (-1) || siteUrlPathname.indexOf("ITEM") !== (-1) || siteUrlPathname.indexOf("restaurantListing") !== (-1)) {
                                        return (
                                            <div className="mainMenuList">
                                                <span className="menuName">Store Contact</span>
                                                <ul>
                                                    <li>Phone : {window.sessionStorage.getItem('storeMobile')}</li>
                                                    <li>Email : {window.sessionStorage.getItem('storeEmail')}</li>
                                                </ul>
                                            </div>
                                        )
                                    }
                                    else {
                                        return (
                                            <div className="mainMenuList">
                                                <span className="menuName">{window.sessionStorage.getItem("groupName")} Contact</span>
                                                <ul>
                                                    <li>Phone : {lokalObj.contact_no}</li>
                                                    <li>Email : {lokalObj.contact_email}</li>
                                                </ul>
                                                {this.state.isMediaData.length > 0 ?
                                                    <div className='socialMediaIcons'>
                                                        {this.state.isMediaData.map((obj, index2) =>
                                                            <span>
                                                                <a href={obj.url}>
                                                                    <LazyLoad>
                                                                        <img src={obj.imageFullPath} alt="" />
                                                                    </LazyLoad>
                                                                </a>
                                                            </span>
                                                        )}
                                                    </div>
                                                    : ""}
                                            </div>
                                        )
                                    }
                                })()}
                            </div>
                        </div>
                        <div className="footerBottom">
                            <div className="container">
                                <div className="mainMenuList">
                                    <ul>
                                        {lokalObj.footerLink.map((footerLinkObj, index1) =>
                                            (() => {
                                                if (footerLinkObj.name === 'Privacy Policy' || footerLinkObj.name === 'Terms & Conditions') {
                                                    return (
                                                        <li key={index1}><Link to={{ pathname: "/footerContent/" + footerLinkObj.id, state: { footerData: footerLinkObj } }} >{footerLinkObj.name}</Link></li>
                                                    )
                                                }
                                            })()
                                        )}
                                    </ul>
                                </div>
                                <div className="footerCard">
                                    <LazyLoad>
                                        <img src={card} alt="" />
                                    </LazyLoad>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
